<template>
  <Card back>
    <template v-slot:header>
      <h4 class="d-inline">تنظیمات سامانه مودیان</h4>
      <hr />
    </template>
    <template v-slot:content>
      
        <ChackupTaxSale @StateMojavez="StateMojavez"></ChackupTaxSale>
      
      <div class="container" :id="$route.name" v-if="MojavezPage">
        <div class="row">
          <div class="mb-3">
            <a v-if="Add == 0" class="d-inline float-right mx-2 mt-1" href="javascript:;" @click="Add = 1" title=" افزودن تنظیمات ">
              <h4><i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i></h4>
            </a>
            <a
              v-if="Add != 0"
              class="d-inline float-right mx-2 mt-1"
              href="javascript:;"
              @click="
                Add = 0
                Refresh()
              "
              title="لغو افزودن"
            >
              <h4><i class="fas fa-times text-danger"></i></h4>
            </a>
          </div>
          <div>
            <div class="row mt-2" v-if="Add != 0">
              <div class="col-md-3 col-12 mb-2">
                <small id="LblIsHaghighi">حقیقی</small>
                <div class="form-control text-center">
                  <div class="custom-control custom-switch">
                    <small id="LbltblComboGrpId50" class="ml-2"> حقیقی</small>
                    <input type="checkbox" class="custom-control-input required InputText" id="Done" v-model="DataAxios.isHaghighi" />
                    <label class="custom-control-label" for="Done"> </label>
                    <small class="mr-5"> حقــوقی</small>
                  </div>
                </div>
              </div>

              <div class="col-md-3 col-12 mb-2">
                <small id="LblPersonName">نام شخص</small>
                <input type="text" class="form-control required" v-model="DataAxios.personName" />
              </div>

              <div class="col-md-3 col-12 mb-2">
                <small id="LblCodeMeli" v-if="!DataAxios.isHaghighi">شناسه ملی</small>
                <small id="LblCodeMeli" v-else>کد ملی</small>
                <input @keypress="$ValidNumber($event, 12)" type="text" class="form-control required" v-model="DataAxios.codeMeli" />
              </div>

              <div class="col-md-3 col-12 mb-2">
                <small id="LblMobile">تلفن</small>
                <input @keypress="$ValidNumber($event, 12)" type="text" class="form-control" v-model="DataAxios.tell" />
              </div>

              <div class="col-md-3 col-12 mb-2" v-if="!DataAxios.isHaghighi">
                <small id="LblCodeEghtesadi">کد اقتصادی</small>
                <input @keypress="$ValidNumber($event, 14)" type="text" class="form-control" v-model="DataAxios.codeEghtesadi" />
              </div>

              <div class="col-md-3 col-12 mb-2">
                <small id="LblCodePosti">کد پستی</small>
                <input @keypress="$ValidNumber($event, 10)" type="text" class="form-control" v-model="DataAxios.codePosti" />
              </div>

              <div class="col-md-3 col-12 mb-2">
                <small id="LblUniqueIdentifier">شناسه یکتا</small>
                <input @keypress="$ValidNumber($event, 10)" type="text" class="form-control required" v-model="DataAxios.uniqueIdentifier" />
              </div>

              <div class="col-md-3 col-12 mb-2">
                <small id="LblsandBox">ارسال به صورت آزمایشی</small>
                <div class="form-control text-center">
                  <div class="custom-control custom-switch">
                    <small id="LbltblComboGrpId50" class="ml-2"> آزمایشی</small>
                    <input type="checkbox" class="custom-control-input InputText" id="SandBox" v-model="DataAxios.sandBox" />
                    <label class="custom-control-label" for="SandBox"> </label>
                  </div>
                </div>
              </div>

              <div class="col-md-12 col-12 mb-2">
                <small id="LblPrivateKey">کلید خصوصی</small>
                <input type="text" class="form-control required" v-model="DataAxios.privateKey" />
              </div>

              <div class="col-md-9 col-12 mb-2">
                <small id="LblAddress">آدرس</small>
                <input type="text" class="form-control" v-model="DataAxios.address" />
              </div>

              <div class="col-md-3 col-12 mb-2" v-if="Add == 1">
                <small id="LblSendDelivery">بایگانی</small>
                <div class="form-control text-center">
                  <div class="custom-control custom-switch">
                    <small id="LbltblComboGrpId50" class="ml-2"> بایگانی شود</small>
                    <input type="checkbox" class="custom-control-input InputText" id="IsArchive" v-model="DataAxios.isArchive" />
                    <label class="custom-control-label" for="IsArchive"> </label>
                  </div>
                </div>
              </div>

              <div class="col-12 float-left">
                <button v-if="Add == 1" class="btn btn-success mt-4 text-center" @click="Save"><i class="fad fa-check mt-2 ml-3"></i>ثبت اطلاعات</button>
                <button v-if="Add == -1" class="btn btn-warning mt-4 text-center" @click="Save">ویرایش اطلاعات</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fliud" v-if="MojavezPage">
        <div class="row">
          <div class="col-12" v-if="Add == 0">
            <div class="row">
              <div class="col-12">
                <bnp-grid :key="Render" :hasRowNum="true" :propsColumn="Column" :propsRows="Rows" :action="true">
                  <template slot="action-slot" slot-scope="props">
                    <i class="fad fa-pen-alt hover-warning Pointer mx-3 mt-2" @click="Edit(props.props)" title="ویرایش"></i>
                    <i class="fad fa-trash hover-danger Pointer mx-3 mt-2" @click="QuestionDelete(props.props)" title="حذف"></i>
                  </template>
                  <template slot="isHaghighi" slot-scope="props">
                    <span class="" v-if="props.props.isHaghighi">[ حقیقی ]</span>
                    <span class="" v-else>[ حقوقی ]</span>
                  </template>
                  <template slot="isArchive" slot-scope="props">
                    <div class="" v-if="props.props.isArchive" @click="ChangeStatus(props.props.id)"><span class="btn btn-danger"> بایگانی </span></div>
                    <div class="" v-else @click="ChangeStatus(props.props.id)"><button class="btn btn-success">فعال</button></div>
                  </template>
                </bnp-grid>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
import Card from '@/components/Card/Card.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import ChackupTaxSale from '../ChackupTaxSale.vue'

export default {
  components: { Card, BnpGrid, ChackupTaxSale },
  data() {
    return {
      MojavezPage:false,
      Add: 0,
      Render: 0,
      Rows: [],
      DataAxios: { uniqueIdentifier: '', sandBox: false, privateKey: '', isHaghighi: true, personName: '', codeMeli: '', codeEghtesadi: '', codePosti: '', address: '', tell: '', tblCustomerId: null, isArchive: false },
      customerId: this.$session.get('CustomerInfo').Id,
      Column: [
        {
          name: 'isHaghighi',
          label: 'نوع مشتری',
          visibility: true,
        },
        {
          name: 'personName',
          label: 'نام شخص حقیقی | حقوقی',
          visibility: true,
        },
        {
          name: 'codeMeli',
          label: 'کدملی | شناسه ملی',
          visibility: true,
        },
        {
          name: 'codeEghtesadi',
          label: 'کد اقتصادی',
          visibility: true,
        },
        {
          name: 'codePosti',
          label: 'کد پستی',
          visibility: true,
        },
        {
          name: 'address',
          label: ' آدرس',
          visibility: true,
        },
        {
          name: 'tell',
          label: ' تلفن',
          visibility: true,
        },
        {
          name: 'sandBox',
          label: ' آزمایشی',
          visibility: true,
        },
        {
          name: 'isArchive',
          label: ' وضعیت بایگانی',
          visibility: true,
        },
      ],
    }
  },

  created() {
  
  },

  methods: {
    Save() {
      if (!this.$ValidForm(this.$route.name)) {
        return
      }
      this.DataAxios.tblCustomerId = this.customerId
      let DataAxios_SetSettings = { Action: this.Add == 1 ? 'TaxSettings/Add' : 'TaxSettings/Edit', Method: 'POST', ArryfildValue: this.DataAxios, Token: this.$session.get('Token') }
      this.$PostData(DataAxios_SetSettings)
        .then((res) => {
          //console.log('😎 ~ .then ~ res:', res)
          if (res.isSuccess == true) {
            if (this.Add == 1) {
              this.$toasted.success(res.message, { duration: 3000 })
            } else {
              this.$toasted.success(res.message, { duration: 3000 })
              this.$SetLog(this.DataAxios, 0)
            }
            this.getData()
            this.Add = 0
            this.Render++
          } else {
            this.$toasted.error(res.message, { duration: 3000 })
          }
        })
        .catch((err) => {
          this.$toasted.error('خطای سمت سرور', { duration: 1500 })
          console.error(err)
        })
    },
    getData() {
      this.$PostData_new('get', 'TaxSettings/' + this.customerId)
        .then((res) => {
          if (res.ststus == 'Ok') {
            this.Rows = res.data
            this.Render++
            this.$store.state.OldDataForLog = JSON.stringify(this.Rows)
          } else {
            this.$mySweetDefaultTost('تنظیماتی یافت نشد', 'تنظیماتی یافت نشد', 'info', 2000)
          }
        })
        .catch((err) => {
          this.$mySweetDefaultTost('عملیات ناموفق', 'خطای سمت سرور', 'error', 2000)
          console.error(err)
        })
    },
    ChangeStatus(rowId) {
      var SendData = { Action: 'TaxSettings/ChangeStatusArchive', Method: 'POST', ArryfildValue: null, Token: this.$session.get('Token') }
      var formData = new FormData()
      formData.append('id', rowId)
      formData.append('tblCustomerId', this.customerId)
      SendData.ArryfildValue = formData
      this.$PostFormData(SendData).then((result) => {
        if (result.ststus == 'Not Ok') {
          this.$toasted.error(result.msg, { duration: 3000 })
        }
        if (result.ststus == 'Ok') {
          this.getData()
          this.Render++
        }
      })
    },
    Edit(row) {
      this.Add = -1
      this.DataAxios = row
      this.$store.state.OldDataForLog = JSON.stringify(row)
    },
    Refresh() {
      this.DataAxios = { uniqueIdentifier: '', sandBox: false, privateKey: '', isHaghighi: true, personName: '', codeMeli: '', codeEghtesadi: '', codePosti: '', address: '', tell: '', tblCustomerId: null, isArchive: false }
    },
    QuestionDelete(row) {
      this.$SweetQustion('عملیات حذف', 'از حذف تنظیمات انتخابی اطمینان دارید؟؟', 'warning', 'حذف  تنظیمات', 'انصراف', row, this.Delete, this.Cancel)
    },
    Delete(row) {
      var SendData = { Action: 'TaxSettings/Delete', Method: 'POST', ArryfildValue: null, Token: this.$session.get('Token') }
      var formData = new FormData()
      formData.append('id', row.id)
      SendData.ArryfildValue = formData
      this.$PostFormData(SendData).then((result) => {
        if (result.ststus == 'Not Ok') {
          this.$toasted.error(result.msg, { duration: 3000 })
        }
        if (result.ststus == 'Ok') {
          this.$toasted.success('حذف با موفقیت انجام شد', { duration: 3000 })
          this.$SetLog(row, 1)
          this.getData()
          this.Render++
        }
      })
    },
    StateMojavez(val){
      this.MojavezPage= val
      this.getData();
    }
    
  },
}
</script>
<style >
thead th,td {
  /* font-weight: normal;
  white-space: nowrap !important; */
}
</style>